import { Box, Skeleton, TableCell, TableRow } from "@mui/material";

export default function SkeletonRows() {
    const skeletonRows = Array.from({ length: 10 }).map((_, index) => (
        <TableRow key={index}>
            <TableCell>
                <Skeleton variant="text" width={120} height={20} />
            </TableCell>
            <TableCell>
                <Skeleton variant="text" width={180} height={20} />
            </TableCell>
            <TableCell>
                <Skeleton variant="text" width={100} height={20} />
            </TableCell>
            <TableCell>
                <Skeleton variant="text" width={140} height={20} />
            </TableCell>
            <TableCell>
                <Skeleton variant="text" width={80} height={20} />
            </TableCell>
            <TableCell align="right">
                <Box display="flex" gap={1} justifyContent="flex-end">
                    <Skeleton variant="circular" width={32} height={32} />
                    <Skeleton variant="circular" width={32} height={32} />
                </Box>
            </TableCell>
        </TableRow>
    ));

    return skeletonRows;
}